import { RecurlyError } from './recurlyDataTypes';

const createEmptyRecurlyError = (): RecurlyError => ({
  code: null,
  message: '',
  name: '',
});

export default createEmptyRecurlyError;
